import styled from "@emotion/styled";

export const Ratio = styled.span`
  display: block;
  padding: 4px 8px;
  border-radius: 7px;
  background-color: ${props => props.colorSettings.backgroundColor};
  color: ${props => props.colorSettings.color};
  width: max-content;
`;
